import BaseButton from "../libs/game-engine/src/base/ui/BaseButton";

export default class BetButtonController extends BaseButton {
  constructor(data, displayItemData) {
    super(data, displayItemData);

    this.enabled = true;

  }
}